import Vue from "vue";
import tippy from "tippy.js";

const directive = {
    inserted(el, binding) {
        const checkTextOverflow = (el, binding) => {
            const isOverflowing = el.scrollWidth > el.offsetWidth;
            if (isOverflowing) {
                Vue.nextTick(() => {
                    // 初始化提示框
                    if (!el._tippy) {
                        el._tippy = tippy(el, {
                            ...binding.value,
                            animation: "fade",
                            theme: "max",
                            animateFill: false,
                            delay: [300, 0],
                            duration: [100, 0],
                            a11y: false,
                        });
                    }
                });
            } else {
                // 没有溢出时 销毁 tippy 实例
                if (el._tippy) {
                    el._tippy.destroy();
                    el._tippy = null;
                }
            }
        };

        el.style.overflow = "hidden";
        el.style.textOverflow = "ellipsis";
        el.style.whiteSpace = "nowrap";
        // 初次检查文本溢出
        checkTextOverflow(el, binding);
        el._checkOverflow = checkTextOverflow;
        window.addEventListener("resize", checkTextOverflow);
        el._destroyTextOverflow = () => {
            window.removeEventListener("resize", checkTextOverflow);
        };
    },
    componentUpdated(el, binding) {
        if (el._checkOverflow) {
            el._checkOverflow(el, binding);
        }
        if (el._tippy) {
            el._tippy.setContent(binding.value.content);
        }
    },
    unbind(el) {
        // 清理事件监听器
        if (el._destroyTextOverflow) {
            el._destroyTextOverflow();
        }
    },
};

export default directive;
